import './bookDemo.scss';
import React from 'react';
import { BookDemoBanner } from './components/@bookDemoBanner/bookDemoBanner';
import { BookDemoContent } from './components/@bookDemoContent/bookDemoContent';
import { BookDemoFooter } from './components/@bookDemoFooter/bookDemoFooter';

interface IProp {
    referUrl: string;
    platform: 'twww' | 'mobile'; // 平台
}

export const BookDemo = (props: IProp) => {
    return (
        <div className="contract-sales">
            <BookDemoBanner {...props} />
            <BookDemoContent {...props} />
            <BookDemoFooter {...props} />
        </div>
    );
};
